import styled from 'styled-components';

const EmojiWrapper = styled.div<{ $relative: boolean }>`
  ${({ $relative }) =>
    $relative &&
    `
      right: 10px;
      bottom: 0px;
      margin-left: 10px;
      position: relative !important;
    `}
`;

const EmojiIconWrapper = styled.div`
  display: flex;
  width: 15px;
  height: 15px;
  z-index: 2;
  cursor: pointer;
`;

const EmojiBox = styled.div`
  z-index: 301;
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* Let @floating-ui inline coords win over legacy .emoji-box rules in app.less */
  bottom: auto !important;
  right: auto !important;

  &[data-open-above='true'] {
    /*
     * @emoji-mart v5 renders <em-emoji-picker>, not the legacy .emoji-mart class.
     * Cap the host height directly so its grid scrolls internally. No overflow:
     * hidden here — it would clip the picker's own :host box-shadow.
     */
    em-emoji-picker {
      min-height: 0 !important; /* override shadow DOM :host min-height: 230px */
      max-height: var(--emoji-picker-max-height, 100%) !important;
    }
  }
`;

export const Styled = {
  EmojiWrapper,
  EmojiIconWrapper,
  EmojiBox,
};
